export default "__VITE_ASSET__a796b4e2__"